import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';

const newsOnly = newsList
  .filter((a) => a.type === 'news')
  .sort((a, b) => (a.date < b.date ? 1 : -1));

const featured = newsOnly[0];
const latestList = newsOnly.slice(1, 6);

export default function LatestNews() {
  return (
    <section>
      <SectionHeading
        eyebrow="Latest News"
        title="最新资讯"
        subtitle="第一时间掌握原神版本动态、活动情报与玩法解析"
        action={{ label: '全部资讯', to: '/news' }}
      />

      <div className="flex flex-col gap-5">
        {featured && <ArticleCard article={featured} variant="featured" />}
        <div className="flex flex-col gap-3">
          {latestList.map((article) => (
            <ArticleCard key={article.id} article={article} variant="horizontal" />
          ))}
        </div>
        <Link
          to="/news"
          className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          查看更多资讯
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}